import { Hotspot } from './hotspot.model';
import * as moment from 'moment';

export class HotspotAlert {

  public id: string;
  public userId: string;
  public region: string;
  public loadsIds: string[];
  public loadsNumbers: string[];
  public vehicleId: string;
  public hotspot: Hotspot;
  public enteredAt: moment.Moment;
  public leftAt: moment.Moment;
  public recordedAt: moment.Moment;

  static fromDto(a): HotspotAlert {
    const alert = new HotspotAlert();

    alert.id           = a.id;
    alert.userId       = a.user_id;
    alert.region       = a.region ? a.region.name : '';
    alert.loadsIds     = a.loads_ids || [];
    alert.loadsNumbers = a.loads_numbers || [];
    alert.vehicleId    = a.vehicle_id;
    alert.hotspot      = Hotspot.fromDto(a.hotspot);
    alert.userId       = a.user_id;
    alert.enteredAt    = moment(a.entered_at);
    alert.leftAt       = moment(a.left_at);
    alert.recordedAt   = moment(a.recorded_at);

    return alert;
  }

}
